import React, { useContext } from "react";
import "./Home.css";
import HomeCards from "./HomeCards/HomeCards";
import { RootStoreContext } from "../../app/stores/rootStore";

const Home = () => {
  const rootStore = useContext(RootStoreContext);
  const siteName = rootStore.generalStore.appVars?.siteName || "DAIKON";

  return (
    <div className="Home">
      {/* Title & description hidden — uncomment to restore
      <h1>{`Data Acquisition, Integration and Knowledge capture application (${siteName})`}</h1>
      <div className="subtext">
        <p>
          {siteName} is a tool for visualizing and
          managing targets, pre-projects and projects within the TBDA and its
          discovery portfolio.
        </p>
        <p>
          This is intended to be used by Program and Portfolio Managers, Project
          Managers, and Scientists.
        </p>
      </div>
      */}
      <HomeCards />
    </div>
  );
};

export default Home;
